import { useContext } from 'react';
import { NotificationsContext, type NotificationsState } from './NotificationsContext';

/** The unread count, and the way to ask for it again. */
export function useNotifications(): NotificationsState {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error('useNotifications must be used inside a NotificationsProvider');
  }
  return context;
}
